// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import Helper from "../../../helper/Helper";
import { Dropdown, LocaleLink, Button, Icon } from "../../common";
import styles from "./CreateTransfers.scss";

class CreateTransfers extends Component {
  state = {
    id_partner_warehouse_from: "",
    id_partner_warehouse_to: "",
    id_partner_warehouse_from_error: false,
    id_partner_warehouse_to_error: false
  };

  dropdownChange(e: Object, key: any) {
    var newState = {};
    newState[`${key}`] = e.value;
    newState[`${key}_error`] = false;
    this.setState(newState);
    if (key === "id_partner_warehouse_from") {
      const query = `?is_fbn=1&id_partner_warehouse=${e.value}`;
      this.props.getWareHouses(query);
    }
  }

  onSubmit = () => {
    const newState = this.state;
    let valid = true;
    if (!this.state.id_partner_warehouse_from) {
      newState.id_partner_warehouse_from_error = true;
      valid = false;
    }
    if (!this.state.id_partner_warehouse_to) {
      newState.id_partner_warehouse_to_error = true;
      valid = false;
    }

    if (valid) {
      const { id_partner_warehouse_from, id_partner_warehouse_to } = this.state;
      const whObj = {
        id_partner_warehouse_from,
        id_partner_warehouse_to
      };
      this.props.openFbnAsn(whObj);
    }
    this.setState(newState);
  };

  render() {
    const {
      isExporting,
      warehouses,
      isOpening,
      exportEligibleOffers,
      fbnWarehouses
    } = this.props;

    const {
      id_partner_warehouse_from,
      id_partner_warehouse_to,
      id_partner_warehouse_from_error,
      id_partner_warehouse_to_error
    } = this.state;

    let fromOptions = [];
    let toOptions = [];

    if (warehouses && !_.isEmpty(warehouses)) {
      for (let i = 0; i < warehouses.length; i++) {
        const eachOption = {
          value: warehouses[i].id_warehouse,
          key: warehouses[i].id_warehouse,
          label: warehouses[i].code
        };
        if (Number(warehouses[i].is_fbn)) {
          // toOptions.push(eachOption);
        } else {
          fromOptions.push(eachOption);
        }
      }
    }

    if (fbnWarehouses && !_.isEmpty(fbnWarehouses)) {
      for (let i = 0; i < fbnWarehouses.length; i++) {
        const eachOption = {
          value: fbnWarehouses[i].id_warehouse,
          key: fbnWarehouses[i].id_warehouse,
          label: fbnWarehouses[i].code
        };
        // if (Number(warehouses.warehouses[i].is_fbn)) {
        toOptions.push(eachOption);
        // } else {
        // fromOptions.push(eachOption);
        // }
      }
    }

    return (
      <div className={styles.ctr}>
        <h3 className={styles.title}>
          {I18n.getText("transfers.select-warehouse")}
        </h3>
        <div className={styles.formctr}>
          <div className={styles.eachInput}>
            <label>{I18n.getText("transfers.wh-from")}</label>
            <div className={styles.dropdownWrapper}>
              {I18n.getComponent(
                formattedValue => (
                  <Dropdown
                    options={fromOptions}
                    height="short"
                    placeholder={formattedValue}
                    value={id_partner_warehouse_from}
                    onChange={e =>
                      this.dropdownChange(e, "id_partner_warehouse_from")
                    }
                  />
                ),
                "dropdown.select"
              )}
              {id_partner_warehouse_from_error ? (
                <div className={styles.error}>
                  <Icon name="warning" /> {I18n.getText("transfers.valid-wh")}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={styles.eachInput}>
            <label>{I18n.getText("transfers.wh-to")}</label>
            <div className={styles.dropdownWrapper}>
              {I18n.getComponent(
                formattedValue => (
                  <Dropdown
                    options={toOptions}
                    height="short"
                    placeholder={formattedValue}
                    value={id_partner_warehouse_to}
                    onChange={e =>
                      this.dropdownChange(e, "id_partner_warehouse_to")
                    }
                  />
                ),
                "dropdown.select"
              )}
              {id_partner_warehouse_to_error ? (
                <div className={styles.error}>
                  <Icon name="warning" /> {I18n.getText("transfers.valid-wh")}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className={styles.fbnExport}>
          <h3 className={styles.title}>
            {I18n.getText("transfers.eligible-for-fbn")}
          </h3>
          <Button
            variant="transparent"
            className={styles.printCtr}
            onClick={() => exportEligibleOffers()}
          >
            <Icon name="download" className={styles.printIcon} />
            {isExporting ? (
              <div className={styles.loader} />
            ) : (
              I18n.getText("transfers.export-csv")
            )}
          </Button>
        </div>
        <div className={styles.btnCtr}>
          <LocaleLink to={`/transfers`}>
            <Button variant="transparent" className={styles.printCtr}>
              {I18n.getText("transfers.cancel")}
            </Button>
          </LocaleLink>

          <Button className={styles.printCtr} onClick={this.onSubmit}>
            {isOpening ? (
              <div className={styles.loader} />
            ) : (
              I18n.getText("transfers.confirm")
            )}
          </Button>
        </div>
      </div>
    );
  }
}
export default CreateTransfers;



// WEBPACK FOOTER //
// ./src/components/transfers/createTransfers/CreateTransfers.js